const ALWAYS_EMPTY_ARRAY = Object.freeze([]);

const asArray = (value) => (Array.isArray(value) ? value : ALWAYS_EMPTY_ARRAY);

// noinspection JSUnusedGlobalSymbols
export default asArray;
